import React from 'react';
import PropTypes from 'prop-types';
import gql from 'graphql-tag';
import { graphql, compose } from 'react-apollo';
import { injectIntl } from 'react-intl';
import { Alert } from 'react-bootstrap';

class NotificationBar extends React.Component {
  static propTypes = {
    activeNotificationsQuery: PropTypes.shape({
      loading: PropTypes.bool,
      activeNotifications: PropTypes.array,
    }).isRequired,
  };

  render() {
    const priorityClasses = {
      high: 'danger',
      medium: 'warning',
      low: 'success',
    };

    const notifications = this.props.activeNotificationsQuery
      .activeNotifications;

    return (
      <>
        {notifications &&
          notifications.map(notification => (
            <div
              key={notification.title}
              style={{ paddingLeft: '15px', paddingRight: '15px' }}
            >
              <Alert
                bsStyle={priorityClasses[notification.priority]}
                style={{
                  borderLeft: '5px solid',
                  borderBottom: '1px solid',
                  borderRight: '1px solid',
                }}
              >
                <h4
                  className="text-left"
                  style={{ marginBottom: 0, fontWeight: 'normal' }}
                >
                  <strong>{notification.title}: </strong>
                  {notification.message}
                </h4>
              </Alert>
            </div>
          ))}
      </>
    );
  }
}

const activeNotificationsQuery = gql`
  query activeNotifications {
    activeNotifications {
      title
      message
      datetime_from
      datetime_to
      priority
    }
  }
`;

export default compose(
  graphql(activeNotificationsQuery, {
    name: 'activeNotificationsQuery',
    options: {
      fetchPolicy: 'network-only',
    },
  }),
)(injectIntl(NotificationBar));
